import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './routes/Login';
import { AuthCallback } from './routes/AuthCallback';
import { Tenants } from './routes/Tenants';
import { TenantDetail } from './routes/TenantDetail';

/**
 * Router del panel de super-admin.
 *
 * No hay "guard" de ruta cliente: la única autoridad es la cookie de sesión.
 * /tenants intenta cargar y, si recibe 401, redirige a /login por sí mismo.
 * Esto evita un guard que confíe en estado de cliente fácilmente falsificable.
 */
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/tenants" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/tenants/:id" element={<TenantDetail />} />
        <Route path="*" element={<Navigate to="/tenants" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
